import { useTranslation } from 'react-i18next'

import { deleteExternalContactProfile } from '../../../../../api'
import { LIST_ROUTE_NAMES } from '../../../../../constants/route'
import { useNotification } from '../../../../../hooks'
import { ConfirmationModal } from '../../../../Confirmation'
import { useUserProfileContext } from '../../../../User'

import { QA_NAME_USER_PROFILE_PAGE_DELETE_ACTION_CONFIRMATION } from './useUserProfilePageDeleteAction.constants'

// External contacts are hard-deleted (no archive/restore for the role) —
// after the 204 leave for the webapp-only external contacts list without a
// reload or success toast, mirroring the webapp flow.
export function useUserProfilePageDeleteAction() {
  const { t } = useTranslation()

  const { handleCloseModal, setModal, setPerformingAction, userData } =
    useUserProfileContext()

  const { handleAddErrorNotification } = useNotification()

  async function handleDelete() {
    handleCloseModal()
    setPerformingAction(true)

    return deleteExternalContactProfile({ id: userData.id })
      .then(() => {
        window.location.replace(LIST_ROUTE_NAMES.externalContacts())
      })
      .catch(error => {
        const detail = error?.response?.data?.detail

        handleAddErrorNotification(
          detail ? { title: detail } : 'Error.CommonApiRequestFailKey'
        )
      })
      .finally(() => {
        setPerformingAction(false)
      })
  }

  function handleClickDelete() {
    setModal(
      <ConfirmationModal
        actionButtonsProps={{ submitText: t('Modal.DeleteBtnKey') }}
        description={t('Modal.ExternalContactDeleteConfirmationTextKey')}
        qaName={QA_NAME_USER_PROFILE_PAGE_DELETE_ACTION_CONFIRMATION}
        onCancel={handleCloseModal}
        onSubmit={handleDelete}
      />
    )
  }

  return { handleClickDelete }
}
